import { render, staticRenderFns } from "./ComponentScoreSave.vue?vue&type=template&id=5a1d4a80&"
import script from "./ComponentScoreSave.vue?vue&type=script&lang=js&"
export * from "./ComponentScoreSave.vue?vue&type=script&lang=js&"
import style0 from "./ComponentScoreSave.vue?vue&type=style&index=0&id=5a1d4a80&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports